import { requestJson } from "./apiClient";
import { NEWS_CONFIG } from "../config/newsConfig";
import { safeHttpUrl } from "../utils/safeUrl";

const normalizePopup = (value) => {
  if (!value || typeof value !== "object") return null;
  const id = Number(value.id);
  const type = String(value.type || "info").trim().toLowerCase();
  const title = String(value.title || "").trim();
  const body = String(value.body || "").trim();
  const imageUrl = safeHttpUrl(value.image_url);
  const ctaLabel = String(value.cta_label || "").trim();
  const ctaUrl = safeHttpUrl(value.cta_url);
  const frequency = String(value.frequency || "session").trim().toLowerCase();
  const version = String(value.version || "").trim();
  const delaySeconds = Math.max(0, Math.min(60, Number(value.delay_seconds) || 0));

  if (!Number.isFinite(id) || id < 1 || !["info", "warning", "success", "important"].includes(type)) return null;
  if (!title && !body && !imageUrl) return null;
  if ((ctaLabel && !ctaUrl) || (!ctaLabel && ctaUrl)) return null;
  if (!["session", "6h", "12h", "24h", "always"].includes(frequency)) return null;

  return {
    id: Math.floor(id), type, title, body, imageUrl, ctaLabel, ctaUrl,
    frequency, dismissForever: Boolean(value.dismiss_forever), delaySeconds, version,
  };
};

export const fetchPopupNotice = async ({ surface, device, signal }) => {
  const params = new URLSearchParams({ type: "popup", surface, device });
  const response = await requestJson({
    url: `${NEWS_CONFIG.apiUrl}?${params.toString()}`,
    operation: "popup-notice",
    signal,
    timeoutMs: 5000,
    defaultMessage: "دریافت اطلاعیه با مشکل مواجه شد",
  });
  if (!response?.success || !response?.data || typeof response.data !== "object") {
    throw new Error("Invalid popup response");
  }
  return normalizePopup(response.data.popup);
};

export const recordPopupEvent = async ({ popupId, event, surface, device }) => {
  if (!popupId || !["shown", "closed", "clicked"].includes(event)) return;
  const eventSurface = ["home", "focus"].includes(String(surface || "").trim().toLowerCase())
    ? String(surface).trim().toLowerCase()
    : "unknown";
  const eventDevice = ["mobile", "desktop"].includes(String(device || "").trim().toLowerCase())
    ? String(device).trim().toLowerCase()
    : "unknown";
  try {
    await requestJson({
      url: `${NEWS_CONFIG.apiUrl}?type=popup_event`,
      operation: "popup-event",
      timeoutMs: 3000,
      defaultMessage: "ثبت رویداد اطلاعیه با مشکل مواجه شد",
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ popup_id: popupId, event, surface: eventSurface, device: eventDevice }),
    });
  } catch (_error) {
    // Analytics is intentionally best-effort and never blocks the product UI.
  }
};
